import type { FC } from 'react'

import { Td } from '@skytech/ui/Table/Td'
import { TrButton } from '@skytech/ui/Table/TrButton'

import CheckboxIcon from '@/components/CheckboxIcon'
import Highlight from '@/components/Highlight'

const DepartmentListItem: FC<{
  id: number
  name: string
  code: string
  customerName: string
  selectedDepartmentIds: number[] | null
  searchQuery?: string
  isSingleChoiceList?: boolean
  onDepartmentSelect: (id: number) => void
}> = ({
  id,
  name,
  code,
  customerName,
  selectedDepartmentIds,
  searchQuery,
  isSingleChoiceList,
  onDepartmentSelect,
}) => {
  const isSelected = Boolean(selectedDepartmentIds?.includes(id))

  return (
    <TrButton onClick={() => onDepartmentSelect(id)} className={`${isSelected ? 'selected' : ''}`}>
      <CheckboxIcon isSelected={isSelected} isSingleChoiceList={isSingleChoiceList} />

      <Td>
        <Highlight pattern={searchQuery} text={name} />
      </Td>

      <Td className="is-mobile-hidden">
        <Highlight pattern={searchQuery} text={customerName} />
      </Td>

      <Td>
        <Highlight pattern={searchQuery} text={code} />
      </Td>
    </TrButton>
  )
}

export default DepartmentListItem
